<div>
  <div class="task-title flex flex-col full-grow-no-shrink-no-basis task-title" (click)="startTitleEdit($event)"
       *ngIf="!isTitleEditing">{{card.title}}</div>
  <particle-inplace-input (cancelled)='resetTitleEditing()'
                          (valueChanged)="taskTitleChanged($event)"
                          *ngIf="isTitleEditing"
                          [text]="card.title"
                          placeHolder="Title"
  ></particle-inplace-input>
</div>
<div class="m-t-20 m-b-40 flex flex-row justify-start items-center">
  <button class="light-background-button m-r-10" mat-button *ngIf="hasAddAttachmentPermission"
          (click)=onAddAttachment()>
    <i _ngcontent-yau-c52="" class="far fa-paperclip"></i> Add an attachment
  </button>
  <button *ngIf="hasCommentPermission" class="light-background-button m-r-10" mat-button (click)=onAddComment()>
    <i class="far fa-comment-lines"></i>Add a comment
  </button>
  <button class="light-background-button  m-r-10" mat-button
          *ngIf="!card.parentTicket && taskMenuItemsMapper.hasOwnProperty('SubTask')" (click)=onCreateSubtask()>
    <i class="far fa-layer-plus"></i>Create a subtask
  </button>
  <button *ngIf="isSupportMember && canOpenChat" class="light-background-button m-r-10" mat-button (click)=onOpenChat()>
    <i class="fa-comment-alt-lines fa-solid"></i>Open Chat
  </button>
</div>
